module.exports = __webpack_public_path__ + "img/warning.cdc82b2c.svg";